export default "__VITE_ASSET__BSDmucKe__"